
import angular from 'angular';

angular.module('folkeuni').factory('DonationApi', function ($http) {
    var self = this;
    var apiBase = '/api/donations';

    self.sendDonation = function (donationObj) {
        return $http({
            method: 'post',
            data: donationObj,
            url: apiBase
        });
    };
    self.fetchRefundData = function (refundObj) {
        return $http({
            method: 'post',
            data: refundObj,
            url: apiBase + "/refund-info"
        });
    };

    return self;
});